import {toast, ToastOptions} from 'react-toastify'

type NotificationKind = 'success' | 'error' | 'info'

type NotifyInput = {
  message: string
  toastId?: string
}

const baseOptions: ToastOptions = {
  position: 'top-right',
  autoClose: 4500,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
}

function normalizeMessage(message?: string): string {
  if (!message) return ''

  return message
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
}

function emit(kind: NotificationKind, input: NotifyInput) {
  if (!input.message) return

  const payload: ToastOptions = {
    ...baseOptions,
    toastId: input.toastId,
  }

  if (kind === 'success') {
    toast.success(input.message, payload)
    return
  }

  if (kind === 'error') {
    toast.error(input.message, payload)
    return
  }

  toast.info(input.message, payload)
}

function buildRequestToastId(input: {
  method?: string
  path?: string
  statusCode: number
  message?: string
}): string {
  const normalizedMethod = (input.method || 'UNKNOWN').toUpperCase()
  const normalizedPath = input.path || 'unknown-path'
  const normalizedMessage = normalizeMessage(input.message)

  return `${normalizedMethod}:${normalizedPath}:${input.statusCode}:${normalizedMessage}`
}

const NotificationToast = {
  success(input: NotifyInput) {
    emit('success', input)
  },

  error(input: NotifyInput) {
    emit('error', input)
  },

  info(input: NotifyInput) {
    emit('info', input)
  },

  buildRequestToastId,
}

export default NotificationToast
